import { FlexRow, ISODate, VerticalSpace } from '@framework/ui';
import { Divider, Space, Tag } from 'antd';
import * as React from 'react';
import { useTheme } from 'styled-components';
import { CommunicationSubject } from './CommunicationSubject';

export interface ICommunicationCollapseHeaderProps {
  date?: string | Date | null | undefined;
  isDraft?: boolean;
  isManual?: boolean;
  format?: string;
  subject?: string | null;
  protocol?: React.ReactNode;
  actors?: React.ReactNode;
  actions?: React.ReactNode;
}

/**
 * Singola comunicazione header per il collapse (sempre visibile)
 */
export function CommunicationCollapseHeader(
  props: ICommunicationCollapseHeaderProps,
) {
  const {
    date,
    isDraft,
    isManual,
    format,
    subject,
    actors,
    actions,
    protocol,
  } = props;
  const theme = useTheme();

  return (
    <FlexRow responsive right={actions ?? undefined}>
      <div>
        <Space
          size={[4, 0]}
          split={
            date ? <Divider aria-hidden="true" type="vertical" /> : undefined
          }
          wrap
        >
          <Space size={[0, 0]} wrap>
            {!isDraft ? (
              <Tag color="blue">INVIATA</Tag>
            ) : (
              <Tag color={theme.colorSuccess}>BOZZA</Tag>
            )}
            {isManual && <Tag color="red">MANUALE</Tag>}
            {date && (
              <ISODate format={format ?? 'DD/MM/YYYY HH:mm'} date={date} />
            )}
          </Space>
          {protocol}
        </Space>
        <div>
          <VerticalSpace size={3} />
          <CommunicationSubject subject={subject} />
        </div>
        <div>{actors}</div>
      </div>
    </FlexRow>
  );
}
